import { apiGet, apiPost } from '../_common';

export default {
  search(query) {
    return apiGet('/magenta/fiscal/purchase-invoice', query).then(result => result.response);
  },
  find(id) {
    return apiGet(`/magenta/fiscal/purchase-invoice/${id}`).then(result => result.response);
  },
  // files: [{ path, content }], at most 100 per call
  import(files) {
    return apiPost('/magenta/fiscal/purchase-invoice/import', { files }).then(result => result.response);
  },
  // Marks every item still without a product as not a stock product, for invoices not bought for resale
  ignoreItems(id, rememberSupplierCode) {
    return apiPost(`/magenta/fiscal/purchase-invoice/${id}/ignore-items`, { rememberSupplierCode })
      .then(result => result.response);
  },
};
